import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { slider } from './route-animations';
import { ApplicationService } from './core/services/application.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  animations: [ // <-- add your animations here
    slider
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Conferma Pay Developer Website';
  isLoggedIn: Observable<boolean>;

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
  
  constructor (public appService: ApplicationService) {
    this.isLoggedIn = this.appService.isLoggedIn;
  }
  
}
